import type { ChargingStationAgent, VehicleAgent } from "../types";

interface StationPanelProps {
  title: string;
  station: ChargingStationAgent;
  vehicles: VehicleAgent[];
}

export default function StationPanel({ title, station, vehicles }: StationPanelProps) {
  const chargingVehicles = vehicles.filter((vehicle) => station.chargingVehicleIds.includes(vehicle.id));
  const demandKw = station.demandProfileKw[station.demandProfileKw.length - 1] || 0;

  return (
    <div className="flex min-h-[260px] w-full flex-col rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-base font-semibold text-slate-800">{title}</h3>
        <span className="rounded-full bg-slate-100 px-2 py-1 text-xs font-medium text-slate-700">
          Demand: {demandKw} kW
        </span>
      </div>

      <div className="mb-3 grid grid-cols-2 gap-2">
        {station.chargers.map((charger, index) => (
          <div key={charger.id} className="rounded-lg border border-emerald-200 bg-emerald-50 p-2">
            <p className="text-[11px] font-semibold text-emerald-700">Charger {index + 1}</p>
            <p className="truncate text-sm font-medium text-slate-800">
              {charger.vehicleId || "Available"}
            </p>
          </div>
        ))}
      </div>

      <div className="rounded-lg border border-amber-200 bg-amber-50 p-2">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-amber-700">Queue</p>
        <p className="text-sm text-slate-800">{station.waitingQueue.length} vehicles waiting</p>
        {station.waitingQueue.length > 0 && (
          <p className="mt-1 truncate text-xs text-slate-600">{station.waitingQueue.join(", ")}</p>
        )}
      </div>

      <div className="mt-3">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Charging Now</p>
        <div className="mt-1 flex flex-wrap gap-1.5">
          {chargingVehicles.length === 0 ? (
            <span className="text-xs text-slate-500">No active charging</span>
          ) : (
            chargingVehicles.map((vehicle) => (
              <span
                key={vehicle.id}
                className="rounded-md bg-emerald-600 px-2 py-1 text-xs font-medium text-white"
              >
                {vehicle.id}
              </span>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
